import { createSlice, nanoid } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import type {
  TToast,
  TToastTone,
  TToastsState,
} from '@/shared/redux/toasts/toasts.types';

// The prototype shows one toast at a time. A real action can answer while
// another is still on screen, so a few stack rather than replacing each other.
export const MAX_VISIBLE_TOASTS = 3;

const initialState: TToastsState = {
  items: [],
};

const toastsSlice = createSlice({
  name: 'toasts',
  initialState,
  reducers: {
    dismissToast: (state, { payload }: PayloadAction<string>) => ({
      items: state.items.filter((toast) => toast.id !== payload),
    }),
    showToast: {
      prepare: (message: string, tone: TToastTone = 'info') => ({
        payload: { id: nanoid(), message, tone },
      }),
      reducer: (state, { payload }: PayloadAction<TToast>) => ({
        items: [...state.items, payload].slice(-MAX_VISIBLE_TOASTS),
      }),
    },
  },
});

export const { dismissToast, showToast } = toastsSlice.actions;
export const toastsReducer = toastsSlice.reducer;
